import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';

import { EditCellProps } from './types';
import { BankDetailsRegistration } from '../bankDetailsRegistration';

export const EditBankDetailsCell = ({ row, personIdLogged }: EditCellProps) => {
  const [showModalEdit, setShowModalEdit] = useState(false);
  const handleOpenModalEdit = () => setShowModalEdit(true);
  const handleCloseModalEdit = () => {
    setShowModalEdit(false);
  };

  return (
    <>
      <BankDetailsRegistration
        editMode={true}
        bankDetailsData={row}
        personIdLogged={personIdLogged}
        isBankDetailsRegistrationModalOpen={showModalEdit}
        onClose={handleCloseModalEdit}
      />
      <IconButton onClick={() => handleOpenModalEdit()} disabled={row.strike} style={{ cursor: 'pointer' }}>
        <EditIcon />
      </IconButton>
    </>
  );
};
